import React from 'react';

const OptionIcon = () => (
    <svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='18' height='18'>
        <circle cx='9' cy='9' r='8' stroke='#888' strokeWidth='0.5' fill='transparent' />
        <circle className='inner' cx='9' cy='9' r='6' fill='transparent' />
    </svg>
);


const OptionIconChecked = () => (
    <svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='18' height='18'>
        <>
            <circle cx='9' cy='9' r='8' stroke='#00787a' strokeWidth='1' fill='transparent' />
            <circle cx='9' cy='9' r='6' fill='#00787a' />
        </>
    </svg>
);

export { OptionIcon, OptionIconChecked };